










import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';

interface TabConfig {
  type: string,
  items?: any,
  editable?: boolean,
  beforeLeave?: Function
}

@Component({
  name: 'mcTabs'
})
export default class extends Vue {
  @Prop() private value: any;
  @Prop({ default: () => [] }) private config!: TabConfig;
  @Prop() private extension?: (value: any) => void;
  private activeName: any = this.value;

  // 检测值
  @Watch("value")
  onValueChanged(val: string) {
    this.activeName = val;
  }

  mounted() {
    this.extension && this.extension({
      setDisabled: (key: string, isDisabled: boolean = true) => {
        const currentItem = this.config.items.find((item: any) => key === item.name);
        this.$set(currentItem, 'disabled', isDisabled)
      },
      setDisableds: (data: any) => {
        this.config.items.forEach((item: any) => {
          if (data[item.name] !== undefined) this.$set(item, 'disabled', data[item.name])
        });
      }
    });
  }

  /**
   * 点击tab事件
   * @param tab tab选项卡
   * @param event 点击事件
   */
  @Emit('on-change')
  handleClick(tab: any, event: any) {
    this.$emit('input', tab.paneName);
  }

  /**
   * tab新增和删除事件
   * @param targetName 目标tab的名称
   * @param action 行为 add｜remove
   */
  handleTabsEdit(targetName: string, action: string) {
    if (action === 'add') {
      this.config.items.push({ title: 'New Tab', name: 'newTab' + this.config.items.length });
    }
    if (action === 'remove') {
      const index = this.config.items.findIndex((tab: any) => tab.name === targetName);
      if (targetName === this.activeName) {
        this.$emit('input', (this.config.items[index - 1] || {}).name || (this.config.items[index + 1] || {}).name);
      }
      this.config.items.splice(index, 1);
    }
  }
}
